import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo1/monicaesposo.png";
import Imagen2 from "../../../images/modulo1/eliovejas.png";
import Imagen3 from "../../../images/modulo1/jailerabuelo.png";
import Imagen4 from "../../../images/modulo1/maluisahermano.png";
import Card from "../../../components/Card";
import InputNumber from "../../../components/InputNumber";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo1 } from "../../../routes/Module1";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo1/Actividad3.mp3";

const Actividad3 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: 2 },
    ans2: { value: "", valid: "", correctValue: 4 },
    ans3: { value: "", valid: "", correctValue: 1 },
    ans4: { value: "", valid: "", correctValue: 3 },
  });
  const infoUnidad = modulo1.content[0];
  const infoAct = modulo1.content[0].activities[2];
  const crumbs = [
    {
      title: modulo1.title,
      url: "/" + modulo1.url,
    },
    {
      title:
        modulo1.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo1.content[0].activities[3].name}`,
    linkNext: `${modulo1.url}/${modulo1.content[0].path}/${modulo1.content[0].activities[3].path}`,
    titlePrev: `${modulo1.content[0].activities[1].name}`,
    linkPrev: `${modulo1.url}/${modulo1.content[0].path}/${modulo1.content[0].activities[1].path}`,
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"] === answers[key]["value"]
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...answers, newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: Number(event.target.value) },
    });
  };
  const metadata = {
    color: modulo1.color,
    title: `${modulo1.title} - ${infoAct.name}`,
    name: modulo1.title
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo1.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">Actividad 3</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>
          Para estar bien, todos los miembros de una familia deben colaborar y
          ayudarse.
        </li>
        <li>
          Coloca en la columna de la derecha el número que corresponde a cada
          imagen.{" "}
        </li>
      </ul>
      <div className="row my-5 align-items-center justify-content-center">
        <div className="col-lg-4 col-md-6 col-xs-12">
          <div className="my-1 d-flex align-items-center">
            <div className={`bg-${modulo1.color} circle-option me-3`}>1</div>
            <img src={Imagen1} alt="Familia" className="img-fluid img-80" />
          </div>
          <div className="my-1 d-flex align-items-center">
            <div className={`bg-${modulo1.color} circle-option me-3`}>2</div>
            <img src={Imagen2} alt="Familia" className="img-fluid img-80" />
          </div>
          <div className="my-1 d-flex align-items-center">
            <div className={`bg-${modulo1.color} circle-option me-3`}>3</div>
            <img src={Imagen3} alt="Familia" className="img-fluid img-80" />
          </div>
          <div className="my-1 d-flex align-items-center">
            <div className={`bg-${modulo1.color} circle-option me-3`}>4</div>
            <img src={Imagen4} alt="Familia" className="img-fluid img-80" />
          </div>
        </div>
        <div className="col-lg-4 col-md-6 offset-lg-2 offset-md-0 col-xs-12">
          <Card>
            <div className="d-flex">
              <InputNumber
                answer={answers.ans1}
                onChangeInput={handleAnswers}
                name="ans1"
                max="4"
              />
              Eli pastorea a los animales antes de ir a la escuela.
            </div>
          </Card>

          <Card>
            <div className="d-flex">
              <InputNumber
                answer={answers.ans2}
                onChangeInput={handleAnswers}
                name="ans2"
                max="4"
              />
              María Luisa ayuda a su hermanito con la tarea.
            </div>
          </Card>
          <Card>
            <div className="d-flex">
              <InputNumber
                answer={answers.ans3}
                onChangeInput={handleAnswers}
                name="ans3"
                max="4"
              />
              La mamá y el papá dejan el almuerzo listo antes de salir a
              trabajar.
            </div>
          </Card>
          <Card>
            <div className="d-flex">
              <InputNumber
                answer={answers.ans4}
                onChangeInput={handleAnswers}
                name="ans4"
                max="4"
              />
              El abuelo de Jailer sabe con qué hierbas bajarle la fiebre.
            </div>
          </Card>
          <div className="d-flex w-100 justify-content-end my-4">
            <button
              className={`btn btn-${modulo1.color}`}
              onClick={validateAnswers}
            >
              Enviar respuestas
            </button>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-8 col-12">
          <ul>
            <li>Ahora piensa, ¿cómo colaboras tú con tu familia?</li>
          </ul>
          <textarea className="form-control mb-5 w-80" rows={3} />
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes. Lea las descripciones una
          por una y pregunte a cuál imagen corresponden. Enfatice que ciertos
          roles no tienen por qué estar limitados a hombre o mujeres. Finalice
          pidiendo a algunos niños y niñas que cuenten cómo colaboran con sus
          familias.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad3;
